export default __webpack_public_path__ + "static/media/paperPlane.6942621f.svg";